import { render, staticRenderFns } from "./ThgBillingSelectionItemThgListData.vue?vue&type=template&id=439dcdf8&"
import script from "./ThgBillingSelectionItemThgListData.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingSelectionItemThgListData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCardActions,VForm})
